export interface Content {
  sys: {
    id: string
    contentType: {
      sys: {
        id: string
      }
    }
  }
  fields: {
    [key: string]: unknown
  }
}

export interface MappedContent {
  id: string
  contentType: string
  [key: string]: unknown
}

export function mapContent(content: Content | undefined): MappedContent | undefined {
  if (!content) return undefined

  return {
    id: content.sys.id,
    contentType: content.sys?.contentType?.sys?.id,
    ...content.fields,
  }
}
